import { Controller } from 'stimulus';

class SearchBarController extends Controller {
  onTogglerClick() {
    this.formTarget.classList.add('is-open');
    this.togglerTarget.classList.add('is-hidden');

    this.focusInput();
  }

  onDocumentClick(e) {
    if (!e.target.closest('.search-bar') && !e.target.closest('.search-bar__toggler')) {
      this.formTarget.classList.remove('is-open');
      this.togglerTarget.classList.remove('is-hidden');
    }
  }

  focusInput() {
    setTimeout(() => {
      this.inputTarget.focus();
    }, 300);
  }
}

SearchBarController.targets = [
  'form',
  'input',
  'toggler',
];

export default SearchBarController;
